import type { IconProps } from '../types/IconProps.ts';
export const VolumeOff: IconProps = {
    name: 'VolumeOff',
    children: [
        `<path d="M7 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.72a1 1 0 0 1 .52.14l4 2.4a.5.5 0 0 0 .76-.42V12M10 5.75l.2-.15a.5.5 0 0 1 .8.4v1M16 9a5 5 0 0 1 1.08 3.5M19 5c1.92 1.92 4.47 6.37 2.2 11M2 2l20 20" />`,
    ]
};